// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student_page_wrapper {
  height: 100vh;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
}

.student_page_section {
  min-height: 100vh;
  width: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

@media (max-width: 480px) {
  .student_page_wrapper {
    scroll-snap-type: y proximity;
  }

  .student_page_section:first-child {
    min-height: 50vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/STUDENTPLATFORM/StudentPage/StudentPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".student_page_wrapper {\n  height: 100vh;\n  overflow-y: auto;\n  scroll-snap-type: y mandatory;\n  scroll-behavior: smooth;\n}\n\n.student_page_section {\n  min-height: 100vh;\n  width: 100%;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n}\n\n@media (max-width: 480px) {\n  .student_page_wrapper {\n    scroll-snap-type: y proximity;\n  }\n\n  .student_page_section:first-child {\n    min-height: 50vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
